module.exports = __webpack_public_path__ + "img/30.2b69a5e2.png";